/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Mechanics } from '../../models/Mechanics';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `Mechanics` model.
 */
@Injectable()
export class MechanicsApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, errorHandler);
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - Model instance data
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Mechanics` object.)
   * </em>
   */
  public patchOrCreate(data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   *
   * @param {any} id mechanics id
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - An object of model property name/value pairs
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Mechanics` object.)
   * </em>
   */
  public patchAttributes(id: any, data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `desde` – `{date}` - fecha inicial de la consulta
   *
   *  - `hasta` – `{date}` - fecha final de la consulta
   *
   *  - `pagina` – `{number}` - 
   *
   *  - `query` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * lista de tickets
   */
  public odooTickets(desde: any, hasta: any, pagina: any, query: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/odooTickets";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof desde !== 'undefined' && desde !== null) _urlParams.desde = desde;
    if (typeof hasta !== 'undefined' && hasta !== null) _urlParams.hasta = hasta;
    if (typeof pagina !== 'undefined' && pagina !== null) _urlParams.pagina = pagina;
    if (typeof query !== 'undefined' && query !== null) _urlParams.query = query;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * cuenta la cantidad de tickets entre las fechas
   *
   * @param {object} data Request data.
   *
   *  - `desde` – `{date}` - 
   *
   *  - `hasta` – `{date}` - 
   *
   *  - `query` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Mechanics` object.)
   * </em>
   */
  public cuentaTickets(desde: any, hasta: any, query: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/cuentaTickets";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof desde !== 'undefined' && desde !== null) _urlParams.desde = desde;
    if (typeof hasta !== 'undefined' && hasta !== null) _urlParams.hasta = hasta;
    if (typeof query !== 'undefined' && query !== null) _urlParams.query = query;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * busca tickets de odoo para facturar
   *
   * @param {object} data Request data.
   *
   *  - `pos_reference` – `{string}` - pos_reference
   *
   *  - `amount_total` – `{string}` - amount_total
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * ticket encontrado
   */
  public buscaTicket(pos_reference: any, amount_total: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/buscaTicket";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof pos_reference !== 'undefined' && pos_reference !== null) _urlParams.pos_reference = pos_reference;
    if (typeof amount_total !== 'undefined' && amount_total !== null) _urlParams.amount_total = amount_total;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * crear facturas
   *
   * @param {object} data Request data.
   *
   *  - `ticket` – `{object}` - datos necesarios para facturar
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * cfdi del SAT
   */
  public creaFactura(ticket: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/creaFactura";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof ticket !== 'undefined' && ticket !== null) _urlParams.ticket = ticket;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * genera y descarga archivo xml
   *
   * @param {object} data Request data.
   *
   *  - `uuid` – `{string}` - uuid
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * xml
   */
  public generaDescargaXml(uuid: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/generaDescargaXml";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof uuid !== 'undefined' && uuid !== null) _urlParams.uuid = uuid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * obtiene el ticket desde odoo
   *
   * @param {object} data Request data.
   *
   *  - `pos_reference` – `{string}` - pos_reference
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * ticket
   */
  public obtenTicketOdoo(pos_reference: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/obtenTicketOdoo";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof pos_reference !== 'undefined' && pos_reference !== null) _urlParams.pos_reference = pos_reference;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * timbrarMasivo
   *
   * @param {object} data Request data.
   *
   *  - `tickets` – `{any}` - arreglo de tickets
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public timbrarMasivo(tickets: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/timbrarMasivo";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof tickets !== 'undefined' && tickets !== null) _urlParams.tickets = tickets;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * cancelarMasivo
   *
   * @param {object} data Request data.
   *
   *  - `ticketsIds` – `{any}` - cancelarMasivo
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public cancelarMasivo(ticketsIds: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/cancelarMasivo";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof ticketsIds !== 'undefined' && ticketsIds !== null) _urlParams.ticketsIds = ticketsIds;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * obtenProductosOdoo
   *
   * @param {object} data Request data.
   *
   *  - `busca` – `{string}` - busca producto
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * obtenProductosOdoo
   */
  public obtenProductosOdoo(busca: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/obtenProductosOdoo";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof busca !== 'undefined' && busca !== null) _urlParams.busca = busca;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * obtenSo
   *
   * @param {object} data Request data.
   *
   *  - `nombre` – `{string}` - nombre
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * odoo invoice
   */
  public obtenSo(nombre: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/obtenSo";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof nombre !== 'undefined' && nombre !== null) _urlParams.nombre = nombre;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * creaFacturaSO
   *
   * @param {object} data Request data.
   *
   *  - `invoice` – `{object}` - odoo invoice
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * cfdi
   */
  public creaFacturaSO(invoice: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/creaFacturaSO";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof invoice !== 'undefined' && invoice !== null) _urlParams.invoice = invoice;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * creaNotaCredito
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - data
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * response
   */
  public creaNotaCredito(data: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/creaNotaCredito";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof data !== 'undefined' && data !== null) _urlParams.data = data;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * buscaPartner
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - data
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * response
   */
  public buscaPartner(data: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/mechanics/buscaPartner";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof data !== 'undefined' && data !== null) _urlParams.data = data;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `Mechanics`.
   */
  public getModelName() {
    return "Mechanics";
  }
}
